import { useEffect, useState, forwardRef } from "react";

import placeHolder from "../../../assets/images/frenchtech_placeholder.jpg";

const InstitutionItem = forwardRef(
  (
    {
      etablissement,
      selectedInstitution,
      setSelectedInstitution,
      filters,
      setMapScreen,
      scrollbarRef,
      allEtablissements,
      filtersKeys,
    },
    ref
  ) => {
    const [isSelected, setIsSelected] = useState(false);

    //--- Get overlayScrollbar Instance from the parent component
    let scrollbarInstance = {};
    if (scrollbarRef.current) {
      scrollbarInstance = scrollbarRef.current.osInstance();
    }

    //--- Scroll the selected institution to the top
    const scrollTo = (etablissementArray, idToCompare, e) => {
      const i = etablissementArray.findIndex((elt) => elt.id === idToCompare);
      const { viewport } = scrollbarInstance.elements();
      viewport.scrollTo({
        top: e.currentTarget.offsetTop,
        behavior: "smooth",
      });
    };

    //--- Control if current item is active or not
    useEffect(() => {
      if (selectedInstitution) {
        if (selectedInstitution.id === etablissement.id) {
          setIsSelected(true);
          document.body.classList.add("no-scroll");
          setMapScreen(true);
        } else {
          setIsSelected(false);
        }
      } else {
        setIsSelected(false);
      }
    }, [selectedInstitution]);

    //--- Trigger auto-scroll, set the selected item state
    const handleShowInstitution = (etablissement, e) => {
      scrollTo(allEtablissements, etablissement.id, e);
      setSelectedInstitution((prev) => {
        if (prev) {
          if (prev.id === etablissement.id) {
            return null;
          } else {
            return etablissement;
          }
        } else {
          return etablissement;
        }
      });
    };

    //--- Create a list of icons composed of the type of activity the entity has
    const iconList = [];
    // for (const category of etablissement[Object.keys(filters)[1]]) {
    //   for (const cat of filters[Object.keys(filters)[1]].values) {
    //     if (category === cat.slug) {
    //       iconList.push(cat.icon);
    //     }
    //   }
    // }

    //     let typeComponent = [];
    //     for (const element of etablissement[Object.keys(filters)[1]]) {
    //       for (const filter of filters[Object.keys(filters)[1]].values) {

    //         if (element === filter.slug) {
    //          {typeComponent.push(<span style={{marginRight:'5px'}}>{element}</span>)}
    //         }
    //       }
    //     }
    // console.log(typeComponent);

    // const typeComponent = etablissement[Object.keys(filters)[1]].map((item, index) => {
    //   for (const filter of filters[Object.keys(filters)[1]].values) {
    //     if (item === filter.slug) {
    //       return (
    //         <span key={index} style={{ marginRight: "5px" }}>
    //           {item}
    //         </span>
    //       );
    //     }
    //   }
    // });

    let colorsArray = [];
    //--- Create Array of colors looping on first filter key
    // for (const element of etablissement[Object.keys(filters)[0]]) {
    //   for (const filter of filters[Object.keys(filters)[0]].values) {
    //     if (element === filter.slug) {
    //       colorsArray.push(filter.color);
    //     }
    //   }
    // }

    //--- Create the color bands depending on the colors Array created above
    // const colorBands = colorsArray.map((color, index) => {
    //   return (
    //     <span
    //       key={color + index}
    //       style={{ display: "inline-block", width: "50px", height: "5px", backgroundColor: `${color}` }}
    //     ></span>
    //   );
    // });

    return (
      <div
        className={`inst-item ${isSelected ? "active " : ""}d-flex`}
        key={etablissement.id}
        onClick={(e) => handleShowInstitution(etablissement, e)}
        ref={ref}
      >
        <div className="inst-item__img-wrapper">
          <img
            // src={etablissement.picture ? etablissement.picture : placeHolder}
            src={etablissement.picture}
            alt="picture"
            width="70"
            height="70"
          />
        </div>
        <div className="d-flex flex-column content">
          {/* <div className="d-flex inst-item__color-band ">{colorBands}</div> */}
          <div className="pb-2 content-wrapper">
            <div className={`inst-item__name`}>{etablissement.name}</div>
            <div className="inst-item__address">{etablissement.address}</div>
            {etablissement?.phone ? (
              <div className="inst-item__phone">
                <span className="iconReactLeafletGroup"></span>
                {etablissement?.phone}
              </div>
            ) : (
              <></>
            )}
            {/* <div className="inst-item__svg-list">{typeComponent}</div> */}
            <div className="inst-item__btns-wrapper">
              {etablissement.website ? (
                <a className="more-infos" href={etablissement.website}>
                  <span className="icon iconReactLeafletinfo"></span>
                  Plus d'infos
                </a>
              ) : (
                <></>
              )}
              <a
                className="itinerary"
                target="_blank"
                href={`https://www.google.com/maps/dir/?api=1&destination=${etablissement.address.replace(
                  " ",
                  "+"
                )}`}
              >
                <span className="iconReactLeafletmarker"></span> Itinéraire
              </a>
              {etablissement?.distance ? (
                <span className="distance-to">{etablissement.distance.toFixed(2)} km(s)</span>
              ) : (
                <></>
              )}
              <span></span>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default InstitutionItem;
